import { css } from "@emotion/react";
import colors from "assets/css/colors";
import fontSize from "assets/css/fontSize";
import fontWeight from "assets/css/fontWeight";

export const wrapperCss = css`
  display: flex;
  flex-direction: column;
  gap: 4px 10px;
`;

export const labelCss = css`
  color: ${colors.textGrey};
  font-weight: ${fontWeight.medium};
  text-transform: capitalize;
  font-size: ${fontSize.sm};
`;

export const errorCss = css`
  color: ${colors.red};
  font-size: ${fontSize.xs};
`;
